export const RATE_LIMIT_ERROR = $.__('This field has been validated too many times, please wait 2 minutes and try again.');
